/** @jsxImportSource theme-ui */
import { Container, Heading } from 'theme-ui';
import EditAction from '@/containers/incentives/EditAction';

const EditActionPage = () => {
    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Edit Action
            </Heading>
            <EditAction />
        </Container>
    );
};

export default EditActionPage;
